import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'antd'
import './index.css'

const ButtonWhiteLink = ({
  buttonText = 'click',
  classes = '',
  to = '/',
  buttonHolderStyles = {},
  buttonStyles = {},
}) => {
  return (
    <div style={buttonHolderStyles} className="button-holder-white-link">
      <Link to={to}>
        <Button style={buttonStyles} className={classes}>
          {buttonText}
        </Button>
      </Link>
    </div>
  )
}

export default ButtonWhiteLink
